import { useEffect, useRef, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Upload, Play } from "lucide-react";
import { toast } from "sonner";

export default function SoundPicker({ value, onChange, testid = "sound-picker" }) {
  const [lib, setLib] = useState([]);
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef();

  const load = async () => { try { setLib((await api.get("/sounds/library")).data); } catch (e) {} };
  useEffect(() => { load(); }, []);

  const upload = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", f);
      const r = await api.post("/sounds/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(r.data.url);
      await load();
      toast.success("Sound uploaded");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Upload failed");
    } finally {
      setUploading(false);
    }
  };

  const preview = (url) => {
    const full = url.startsWith("http") ? url : `${window.location.origin}${url}`;
    new Audio(full).play().catch(() => toast.error("Could not play"));
  };

  return (
    <div className="flex gap-2 items-center">
      <select
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        data-testid={testid}
        className="flex-1 bg-secondary border border-white/10 rounded-lg px-2 py-2 text-sm text-foreground focus:ring-primary focus:outline-none"
      >
        <option value="">No sound</option>
        {lib.map((s) => <option key={s.id} value={s.url}>{s.name}</option>)}
      </select>
      {value && (
        <Button type="button" size="icon" variant="ghost" className="h-9 w-9 hover:text-primary" onClick={() => preview(value)} data-testid={`${testid}-preview`}>
          <Play className="w-4 h-4" />
        </Button>
      )}
      <Button type="button" size="sm" onClick={() => fileRef.current.click()} disabled={uploading} className="bg-cookie text-black hover:bg-cookie/90" data-testid={`${testid}-upload`}>
        <Upload className="w-4 h-4 mr-1" />{uploading ? "…" : "Upload"}
      </Button>
      <input ref={fileRef} type="file" accept="audio/*" className="hidden" onChange={upload} />
    </div>
  );
}
